import script from "./FederationToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./FederationToggle.vue?vue&type=script&setup=true&lang=js"

import "./FederationToggle.vue?vue&type=style&index=0&id=05e30932&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05e30932"]])

export default __exports__